import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=8b727372&scoped=true"
import script from "./iframe.vue?vue&type=script&lang=js"
export * from "./iframe.vue?vue&type=script&lang=js"
import style0 from "./iframe.vue?vue&type=style&index=0&id=8b727372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b727372",
  null
  
)

export default component.exports